import { SET_SETTING, RESET_SETTING } from './actionTypes';
import { currency } from '../../helpers';

export const setSettingAction = () => (dispatch, getState) => {
  const state = getState();

  const cart = state.cart;
  const calendar = state.calendar.current;
  const setting = state.setting;
  const isLastMomentFood = state.menu.list?.some(x => x.isLastMomentFoodItem);
  const payload = {};

  payload.hasFinalOrder = false;
  payload.hasTempOrder = false;

  // حداقل یک غذا از سرور دریافت شده است
  if (cart.list?.length > 0) {
    // غذای موجود ثبت نهایی شده است
    if (cart.finalSubmit) {
      payload.hasFinalOrder = true;

      if (!setting.hasInvoice) {
        payload.hasInvoice = true;
      }
    }
    // غذای موجود در سبد خرید موقت قرار داد و زمان سفارش گیری است
    else if (!calendar.isEndOrderTime) {
      payload.hasTempOrder = true;
    }
  }

  // حداقل یک غذا برای شما ثبت نهایی شده
  if (payload.hasFinalOrder) {
    // زمان سفارش گیری به پایان رسیده است
    if (calendar.isEndOrderTime && !isLastMomentFood) {
      payload.editMode = false;
      payload.showEditOrderButton = false;
      payload.showCancelEditOrderButton = false;
    }
    // زمان سفارش گیری است
    else {
      // اگر کاربر در حال ویرایش است و از قبل سفارش ثبت شده ای ندارد، آخرین وضعیت را اعمال کن
      if (setting.showCancelEditOrderButton && !setting.hasInvoice) {
        payload.editMode = setting.editMode;
      }
      // اگر کاربر در حال ویرایش است و از قبل سفارش ثبت شده ای دارد
      if (setting.showCancelEditOrderButton && setting.hasInvoice) {
        payload.editMode = false;
      }
      // اگر در حال ویرایش نیست و فقط در حال جا به جایی بین روزها است و یا غذایی را ثبت کرده است
      else {
        payload.editMode = false;
        payload.showCancelEditOrderButton = false;
      }

      payload.showEditOrderButton = true;
    }
  }
  // حداقل یک غذا در سبد خرید موقت وجود دارد
  else if (payload.hasTempOrder) {
    payload.editMode = true;
    payload.showEditOrderButton = false;
    payload.showCancelEditOrderButton = true;
  }
  // هیچ غذایی ثبت نشده است و سبد خرید خالی است
  else {
    // زمان سفارش گیری به پایان رسیده است
    if (calendar.isEndOrderTime) {
      payload.editMode = false;
    }
    // زمان سفارش گیری است
    else {
      payload.editMode = true;
    }

    payload.showEditOrderButton = false;
    payload.showCancelEditOrderButton = false;
  }

  // زمان سفارش گیری تمام شده است
  if (calendar.isEndOrderTime && !isLastMomentFood) {
    payload.orderMessage = {
      type: 'order_time_finished',
      text: 'زمان سفارش گیری به اتمام رسیده است',
      icon: 'alert',
      color: 'warning',
    };

    // سفارش ثبت شده وجود دارد
    if (payload.hasFinalOrder) {
      // غذا تحویل شرکت داده شده است
      if (calendar.delivered) {
        payload.orderMessage = {
          type: 'order_delivered',
          text: 'غذا تحویل شرکت داده شده است',
          icon: 'feedback',
          color: 'grayLight',
        };
        // سفارش در حال آماده سازی است
      } else {
        payload.orderMessage = {
          type: 'order_preparing',
          text: 'سفارش در حال آماده سازی است',
          icon: 'notification',
          color: 'grayLight',
        };
      }
    }
  }
  // سفارش ثبت شده است
  else if (payload.hasFinalOrder) {
    // اگه پرداختی مشتری صفر باشد
    if (cart.totalPriceWithCalcSubside === 0) {
      payload.orderMessage = {
        type: 'order_submitted',
        text: 'سفارش شما بدون هزینه ثبت شد',
        icon: 'tick',
        color: 'success',
      };
    }
    // اگر مشتری باید هزینه ای پرداخت کند
    else {
      payload.orderMessage = {
        type: 'order_submitted',
        text: 'سفارش به مبلغ {{price}} ثبت شد',
        textData: {
          price: currency(cart.totalPriceWithCalcSubside),
        },
        icon: 'tick',
        color: 'success',
      };
    }
  } else {
    payload.orderMessage = null;
  }
  if (isLastMomentFood) {
    if (!payload.hasFinalOrder) {
      payload.editMode = true
    }
    payload.showCancelEditOrderButton = true
    payload.showEditOrderButton = true
  }
  dispatch({
    type: SET_SETTING,
    payload,
  });
};

export const enterEditModeAction = () => ({
  type: SET_SETTING,
  payload: {
    editMode: true,
    showEditOrderButton: false,
    showCancelEditOrderButton: true,
  },
});

export const exitEditModeAction = () => ({
  type: SET_SETTING,
  payload: {
    showCancelEditOrderButton: false,
  },
});

export const setHasInvoiceAction = (hasInvoice = true) => ({
  type: SET_SETTING,
  payload: {
    hasInvoice,
  },
});

export const resetSettingAction = () => ({
  type: RESET_SETTING,
  payload: true,
});
